import { createBrowserRouter } from "react-router-dom";
import { ProtectedRoutes } from "@/ProtectedRoute";
import PageNotFound from "@/pages/error/404.page";
import HomePage from "@/pages/home/home.page";
import LoginPage from "@/pages/auth/login.page";
import ProfilePage from "@/pages/profile/profile.page";
import Register from "@/pages/auth/register.page";
import { siteRoutes } from "./siteRoutes";
import JobsOverviewPage from "@/pages/jobs/jobs.overview.page";
import JobsSinglePage from "@/pages/jobs/jobs.single.page";
import JobsCreatePage from "@/pages/jobs/jobs.create.page";
import ProfileUpdate from "@/features/profile/components/manage/Profile.update";
import AdminAuth from "@/features/admin/components/AdminAuth";
import UsersOverviewPage from "@/pages/admin/users/users.overview.page";
import JobsManagePage from "@/pages/jobs/jobs.manage.page";

export const router = createBrowserRouter([
  {
    path: siteRoutes.home.path,
    element: <ProtectedRoutes />,
    errorElement: <PageNotFound />,
    children: [
      {
        path: siteRoutes.home.path,
        element: <HomePage />,
        errorElement: <PageNotFound />,
      },
      {
        path: siteRoutes.profile.view.path,
        element: <ProfilePage />,
        errorElement: <PageNotFound />,
      },
      {
        path: siteRoutes.profile.edit.path,
        element: <ProfileUpdate />,
        errorElement: <PageNotFound />,
      },
      {
        path: siteRoutes.jobs.overview.path,
        element: <JobsOverviewPage />,
        errorElement: <PageNotFound />,
      },
      {
        path: siteRoutes.jobs.view.path,
        element: <JobsSinglePage />,
        errorElement: <PageNotFound />,
      },
      {
        path: siteRoutes.jobs.create.path,
        element: (
          <AdminAuth>
            <JobsCreatePage />
          </AdminAuth>
        ),
        errorElement: <PageNotFound />,
      },
      {
        path: siteRoutes.jobs.edit.path,
        element: (
          <AdminAuth>
            <JobsManagePage />
          </AdminAuth>
        ),
        errorElement: <PageNotFound />,
      },
      {
        path: siteRoutes.admin.users.overview.path,
        element: (
          <AdminAuth>
            <UsersOverviewPage />
          </AdminAuth>
        ),
      },
    ],
  },
  {
    path: siteRoutes.auth.login.path,
    element: <LoginPage />,
    errorElement: <PageNotFound />,
  },
  {
    path: siteRoutes.auth.register.path,
    element: <Register />,
    errorElement: <PageNotFound />,
  },
]);

export const routePaths = router.routes[0].children!;
